import React, { FC, ReactElement, useState, useEffect } from 'react';
import DemoZoneHeader from './DemoZoneHeader/DemoZoneHeader';
import DemoZoneVideos from './DemoZoneVideos/DemoZoneVideos';
import DemoZoneList from './DemoZoneList/DemoZoneList';
import DemoZoneQuestionForm from './DemoZoneQuestionForm/DemoZoneQuestionForm';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsLoggedIn, getIsRegistrationRequired, getDemozoneCustomeThemes } from '../../../stores/reducers/userData';
import routes from '../../../config/routes';
import './demozone.sass';

export interface VideoProps {
  title: string;
  title_en?: string;
  youtubeKey: string;
  description?: string;
  description_en?: string;
  preview?: string | null;
}

export interface ZoneDataProps {
  id: string;
  title: string;
  title_en?: string;
  showOfflineRequest: boolean;
  description: string;
  description_en?: string;
  image: string;
  type: string;
  webinar: string;
  videoArchive: VideoProps[];
  questionBlockShown?: boolean;
  videoBlockTitle?: string | null;
  videoBlockTitle_en?: string | null;
}

interface Props {
  zoneCode: string
}

const DemoZone:FC<Props> = ({ zoneCode }): ReactElement => {
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const shouldRegister = !isLoggedIn && isRegistrationRequired;
  if (shouldRegister) history.push(routes.REGISTER);
  const demoZoneData = useSelector(getDemozoneCustomeThemes);
  const [ activeZoneData, setActiveZoneData ] = useState<any>({});
  const hasFormVisibleIndetify = typeof activeZoneData.questionBlockShown !== 'undefined';

  const showQuestionForm = hasFormVisibleIndetify 
    ? activeZoneData.questionBlockShown && (isLoggedIn || activeZoneData.showOfflineRequest) 
    : (isLoggedIn || activeZoneData.showOfflineRequest);
  
  useEffect(() => {
    const resultActiveZone = demoZoneData.find((zone: ZoneDataProps) => zone.id === decodeURI(zoneCode));
    setActiveZoneData(resultActiveZone);
  }, [demoZoneData, zoneCode]);

  return (
    <>
      {
        activeZoneData && 
          <>
            <DemoZoneHeader zoneData={activeZoneData} />
            {
              activeZoneData.videoArchive && activeZoneData.videoArchive.length &&
              <DemoZoneVideos zoneData={activeZoneData} />
            }
            <DemoZoneList zoneCode={zoneCode} zoneData={activeZoneData} />
            { showQuestionForm && (
              <DemoZoneQuestionForm recepient={activeZoneData.formTitle || 'demozone'} />
            )}
          </>
      }
    </>
  )
}

export default DemoZone;
